const headerSpecifiedBlock = `{
    dynamicBlocks(input: { type: SPECIFIED, locations: HEADER }) {
        items {
            uid
            content {
                html
            }
        }
    }
}`;

const categories = `{
    categories {
        items {
            uid
            name
            url_key
            children {
                uid
                name
                url_key
                category_favicon_image
                children {
                    uid
                    name
                    url_key
                    children {
                        uid
                        name
                        url_key
                    }
                }
            }
        }
    }
}`;

const footerMenu = `{
    getFooter {
        company_info {
            name
            children {
                uid
                name
                url_key
            }   
        }
        service_info {
            name
            children {
                uid
                name
                url_key
            }   
        }
        account_info {
            name
            children {
                uid
                name
                url_key
            }   
        }
        policy_info {
            children {
                uid
                name
                url_key
            }   
        }
    }
}`;

const topMenu = `{
    getTopMenu {
        uid
        name
        url_key
        is_category_root
        children {
            uid
            name
            url_key
        }
    }
}`;

export default {
    headerSpecifiedBlock,
    categories,
    footerMenu,
    topMenu,
};
